import React from 'react';

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export function Spinner({ size = 'md', className = '', ...props }: SpinnerProps) {
  const sizes = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl',
    xl: 'text-6xl',
  };

  return (
    <span
      className={`material-symbols-outlined text-primary animate-spin ${sizes[size]} ${className}`}
      {...props}
    >
      progress_activity
    </span>
  );
}
